import { useQuery } from "@tanstack/react-query";
import {
	getCobblesPickers,
	type GetCobblesPickersParams,
} from "../repositories/CobblesReportRepository";

export const useCobblesPickers = ({
	start,
	end,
}: Omit<GetCobblesPickersParams, "signal">) => {
	return useQuery({
		queryKey: ["cobblesPickers", start, end],
		queryFn: ({ signal }) => getCobblesPickers({ start, end, signal }),
		enabled: !!start && !!end,
	});
};
